import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { getHmacQuery } from "@/app/Settings/Integrations/Rcm/GraphQL/getHmac";
import { useSettingsSupplier } from "@/app/Suppliers/Utils/useSettingsSupplier";

export function useRcmHashRecord(requestBody: string) {
  const { supplier } = useSettingsSupplier();
  const { data } = useSuspenseGqlQuery(getHmacQuery, {
    input: {
      requestBody: requestBody,
      supplierId: supplier?.id,
    },
  });
  return data.getHmac;
}
